import { API_JWT_BASE_URL } from '../http'

export const GET_PROFILE_DETAILS_API = `${API_JWT_BASE_URL}/Users/GetProfileDetails`
export const CHANGE_PROFILE_PICTURE_API = `${API_JWT_BASE_URL}/Users/UploadProfilePicture`

export const USER_PROFILE_QUERY_KEYS = {
  GET_PROFILE_DETAILS: 'GET_PROFILE_DETAILS',
  CHANGE_PROFILE_PICTURE: 'CHANGE_PROFILE_PICTURE'
}
